export default "__VITE_ASSET__C$phKAOw__"